export const tsdexp = /.d.ts$/;
export const mapexp = /.map$/;

export const esmChkExp = /^esm/;
export const tsFileExp = /.ts$/;
export const jsFileExp = /.js$/;
